export const ACCESS_TOKEN = 'accessToken';
export const ENCOUNTER = 'encounter';
export const ID_TOKEN = 'idToken';
